<div class="people-list-item" style="display: flex; align-items: center; justify-content: space-between; gap: 20px">
  <span style="display: flex; align-items: center; gap: 20px">
    <ngx-avatar [src]="image" [name]="avatarName" size="30"></ngx-avatar>
    <div class="details" style="display: flex; flex-direction: column">
      <div>{{ name }}</div>
      <div>{{ email }}</div>
    </div>
  </span>
  <div>
    <ng-content></ng-content>
  </div>
</div>
